/**
 * Created by Ning Jiang on 5/24/2019.
 */

import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite} from "gsap";
import {PixiesVsPiratesGameConfig} from "../PixiesVsPiratesGameConfig";

export class SpinEffects extends BaseView {

    private _spinEffectSprite:PIXI.Sprite;
    private _spinEffectSpine:PIXI.spine.Spine;
    private _timeline:TimelineLite;

    constructor() {
        super();
    }

    protected initAnimations():void {
        this._spinEffectSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("spin_effect"));
        this._spinEffectSpine.autoUpdate = true;
        this._spinEffectSpine.state.setAnimation(0, "spin", false);
        this._spinEffectSpine.state.setEmptyAnimation(0, 0);

        this._spinEffectSprite = new PIXI.Sprite();
        this._spinEffectSprite.anchor.set(0.5, 0.5);
        this._spinEffectSprite.position.set(GameConfig.instance.REEL_AREA_POS_X + GameConfig.instance.REEL_DISPLAY_POSITIONS[2][0] + GameConfig.instance.SYMBOL_WIDTH / 2, GameConfig.instance.REEL_AREA_POS_Y + PixiesVsPiratesGameConfig.instance.REEL_AREA_TOP_BORDER + 134);
        this._spinEffectSprite.visible = false;
        this._spinEffectSprite.addChild(this._spinEffectSpine);

        const effectLayer:ScalableLayer = StageManager.getLayer(PixiesVsPiratesGameConfig.instance.LAYERS.SPIN_EFFECT.name);
        effectLayer.addChild(this._spinEffectSprite);
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onBeforeSpinStart());
        EventHandler.addEventListener(this, SpinEvent.STOP, () => this.onSpinStop());
    }

    private onBeforeSpinStart():void {
        this.resetTimeline();
        this._spinEffectSpine.state.clearTrack(0);
        this._spinEffectSpine.skeleton.setToSetupPose();
        this._spinEffectSpine.state.timeScale = 1;

        this._spinEffectSprite.alpha = 1;
        this._spinEffectSprite.visible = true;
        this._timeline = new SpineTween(this._spinEffectSpine, 0, "spin");
    }

    private onSpinStop():void {
        this.resetTimeline();
        if(this._spinEffectSprite && this._spinEffectSprite.alpha == 1) {
            const timeline:TimelineLite = new TimelineLite();
            timeline.to(this._spinEffectSprite, 0.2, {alpha : 0});
            this._timeline = timeline;
        }
        this._spinEffectSpine.state.timeScale = 15;
    }

    private resetTimeline():void {
        if(this._timeline && this._timeline.isActive()) {
            this._timeline.progress(1);
            this._timeline.kill();
        }
    }
}